<template>
  <div class="search-bus" :class="searchBusAnimation">
    <q-btn
      round
      icon="close"
      color="white"
      text-color="black"
      class="btn__close"
      :class="{'hidden': !showCard}"
      @click="showCard = false"
    />

    <div class="container" @click="showCard = true">
      <h4 class="search-bus__title">
        Busca rápida do carro
        <q-icon name="find_in_page" class="search-bus__icon" />
      </h4>

      <q-separator inset />

      <div class="search-bus__input">
        <span class="search-bus__label">Digite o número do carro</span>

        <q-input
          v-model="busNumber"
          no-caps
          filled
          clearable
          value=""
          label="Número do carro"
          type="number"
          class="card btn--size"
          @clear="clearFilter"
        >
          <template v-slot:prepend>
            <q-icon name="directions_bus" />
          </template>
        </q-input>
      </div>

      <q-btn
        :disable="busNumber === ''"
        no-caps
        label="Pesquisar carro"
        style="background: #3BA46A"
        text-color="white"
        unelevated
        class="card--alternative btn--size btn__search no-shadow"
        @click="searchBus"
      />

      <span class="search-bus__label">ou leia o QR Code do ônibus</span>

      <q-btn class="btn--size btn__qr-code no-shadow" @click="searchWithQRCode">
        <q-icon name="center_focus_weak" size="md" class="q-mr-sm" />
        Ler QR Code
      </q-btn>
    </div>
  </div>
</template>

<script>
  import { store, mutations } from '../../store'

  export default {
    name: 'SearchBus',

    data() {
      return {
        showCard: false,
        busNumber: '',
      }
    },

    computed: {
      searchBusAnimation() {
        return this.showCard ? 'search-bus--show' : 'search-bus--hide'
      },
    },

    methods: {
      searchBus() {
        store.schedules = store.schedules.map((s) => {
          return {
            ...s,
            filtered: s.number_bus.includes(this.busNumber),
          }
        })
      },

      searchWithQRCode() {
        if (this.$q.platform.is.cordova) {
          window.cordova.plugins.barcodeScanner.scan(
            result => {
              this.busNumber = result.text
              this.searchBus()
              this.showCard = false
            },
            error => {
              mutations.openAlert({
                open: true,
                message: error,
                status: 500
              });
            }
          )
        }
      },

      clearFilter() {
        this.busNumber = ''
        this.searchBus()
      },
    },
  }
</script>

<style lang="scss">
.search-bus {
  display: grid;
  grid-row-gap: 12px;

  position: fixed;
  width: 100%;
  bottom: -300px;

  .container {
    display: grid;
    grid-row-gap: 14px;
    place-items: center;

    background-color: #FFFFFF;
    box-shadow: 0 3px 50px rgba(0, 0, 0, 0.35);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;

    width: 100%;
    margin: auto;
  }

  .btn--size {
    width: 200px;
    height: 58px;
  }

}

%animation-slide {
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

$bottom-position: -300px;

.search-bus--show {
  animation-name: slide-up;
  @extend %animation-slide;

  @keyframes slide-up {
    from {
      bottom: $bottom-position;
    }

    to {
      bottom: 0;
    }
  }
}

.search-bus--hide {
  animation-name: slide-up-reverse;
  @extend %animation-slide;

  @keyframes slide-up-reverse {
    from {
      bottom: 0;
    }

    to {
      bottom: $bottom-position;
    }
  }
}

.search-bus__title {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: repeat(2, max-content);

  place-items: center;
  margin: auto;
  padding-top: 12px;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #004B15;
}

.search-bus__icon {
  font-size: 22px;
  color: #004B15;
}

.search-bus__label {
  color: #7A8583;
}

.search-bus__input {
  display: grid;
  grid-row-gap: 8px;
  place-items: center;
}

.btn__close {
  justify-self: end;
  margin-right: 15px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.38);
}

.btn__search {
  font-size: 14px;
  font-weight: 600;
}

.btn__qr-code {
  font-size: 12px;
  font-weight: 500;
  color: #092C1E;
  background-color: #FFFFFF;

  margin-bottom: 15px;
}
</style>
